import React from 'react';
import PropTypes from 'prop-types';
import RocketSvg from './rocket.svg';
import { Button } from '../../Button';
import './PortfolioPopup.css';

export const PortfolioPopup = ({
  handleUploadPortfolio,
  handleUploadPortfolioLater,
}) => (
  <div className="portfolio-popup-content">
    <div className="portfolio-popup-content__image-container">
      <img
        alt="Managed"
        className="portfolio-popup-content__image-container__image"
        src={RocketSvg}
      />
    </div>
    <div className="portfolio-popup-content__body">
      <div className="portfolio-popup-content__body__title">
        Awesome. Now let&apos;s add your portfolio
      </div>
      <div className="portfolio-popup-content__body__description">
        You&apos;ve come this far now it&apos;s time to show our clients what
        you&apos;ve got
        <br />
        with your kick-ass portfolio.
      </div>
    </div>
    <div className="portfolio-popup-content__action">
      <Button
        id="portfolio-popup-upload-button"
        className="portfolio-popup-content__action--upload"
        textClassName="portfolio-popup-content__action--upload-text"
        onClick={handleUploadPortfolio}
        rounded
        block
        title="Upload Portfolio"
      />
      <Button
        id="portfolio-popup-upload-later-button"
        className="portfolio-popup-content__action--upload-later"
        textClassName="portfolio-popup-content__action--upload-later-text"
        onClick={handleUploadPortfolioLater}
        transparent
        block
        withoutTextTransform
        title="I'll upload my portfolio later"
      />
    </div>
  </div>
);

PortfolioPopup.propTypes = {
  handleUploadPortfolio: PropTypes.func,
  handleUploadPortfolioLater: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Popup/PortfolioPopup/PortfolioPopup.js